import React, { useEffect, useState, useContext, useRef } from "react";

import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import useSettings from "../../hooks/useSettings";
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import OnlyForSuperUser from "../OnlyForSuperUser";
import { AuthContext } from "../../context/Auth/AuthContext";

import {
  IconButton,
  InputAdornment,
  Button,
} from "@material-ui/core";

import { Colorize, AttachFile, Delete } from "@material-ui/icons";
import ColorPicker from "../ColorPicker";
import ColorModeContext from "../../layout/themeContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { getBackendUrl } from "../../config";

import defaultLogoLight from "../../assets/logo.png";
import defaultLogoDark from "../../assets/logo-black.png";
import defaultLogoFavicon from "../../assets/favicon.ico";
import ColorBoxModal from "../ColorBoxModal/index.js";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  tab: {
    borderRadius: 4,
    width: "100%",
    "& .MuiTab-wrapper": {
      color: "#128c7e"
    },
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }


  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
    width: "100%",
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },

  uploadInput: {
    display: "none",
  },

  appLogoLightPreviewDiv: {
    backgroundColor: "white",
    padding: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#424242",
    textAlign: "center",
  },

  appLogoDarkPreviewDiv: {
    backgroundColor: "#424242",
    padding: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "white",
    textAlign: "center",
  },

  appLogoFaviconPreviewDiv: {
    padding: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "black",
    textAlign: "center",
  },

  appLogoLightPreviewImg: {
    width: "100%",
    maxHeight: 72,
    content: "url(" + theme.calculatedLogoLight() + ")"
  },

  appLogoDarkPreviewImg: {
    width: "100%",
    maxHeight: 72,
    content: "url(" + theme.calculatedLogoDark() + ")"
  },

  appLogoFaviconPreviewImg: {
    width: "100%",
    maxHeight: 72,
    content: "url(" + ((theme.appLogoFavicon) ? theme.appLogoFavicon : "") + ")"
  }
}));

export default function Whitelabel(props) {
  const { settings } = props;
  const classes = useStyles();
  const [settingsLoaded, setSettingsLoaded] = useState({});

  const { user: currentUser } = useContext(AuthContext);

  const { colorMode } = useContext(ColorModeContext);
  const [primaryColorLightModalOpen, setPrimaryColorLightModalOpen] = useState(false);
  const [primaryColorDarkModalOpen, setPrimaryColorDarkModalOpen] = useState(false);

  const logoLightInput = useRef(null);
  const logoDarkInput = useRef(null);
  const logoFaviconInput = useRef(null);
  const appNameInput = useRef(null);
  const soundTicketInput = useRef(null);
  const soundMessageInput = useRef(null);
  const soundAttentionInput = useRef(null);
  const soundLoginInput = useRef(null);
  const [appName, setAppName] = useState(settingsLoaded.appName || "");

  const { update } = useSettings();

  function updateSettingsLoaded(key, value) {
    console.log("|=========== updateSettingsLoaded ==========|")
    console.log(key, value)
    console.log("|===========================================|")
    if (key === 'primaryColorLight' || key === 'primaryColorDark' || key === 'appName') {
      localStorage.setItem(key, value);
    };
    const newSettings = { ...settingsLoaded };
    newSettings[key] = value;
    setSettingsLoaded(newSettings);
  }

  useEffect(() => {
    if (Array.isArray(settings) && settings.length) {
      const primaryColorLight = settings.find((s) => s.key === "primaryColorLight")?.value;
      const primaryColorDark = settings.find((s) => s.key === "primaryColorDark")?.value;
      const appLogoLight = settings.find((s) => s.key === "appLogoLight")?.value;
      const appLogoDark = settings.find((s) => s.key === "appLogoDark")?.value;
      const appLogoFavicon = settings.find((s) => s.key === "appLogoFavicon")?.value;
      const appName = settings.find((s) => s.key === "appName")?.value;
      const sound_ticket = settings.find((s) => s.key === "sound_ticket")?.value;
      const sound_message = settings.find((s) => s.key === "sound_message")?.value;
      const sound_attention = settings.find((s) => s.key === "sound_attention")?.value;
      const sound_login = settings.find((s) => s.key === "sound_login")?.value;

      setAppName(appName || "");
      setSettingsLoaded({ ...settingsLoaded, primaryColorLight, primaryColorDark, appLogoLight, appLogoDark, appLogoFavicon, appName, sound_ticket, sound_message, sound_attention, sound_login });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  async function handleSaveSetting(key, value) {

    await update({
      key,
      value,
    });
    updateSettingsLoaded(key, value);
    toast.success("Operação atualizada com sucesso.");
  }

  const uploadLogo = async (e, mode) => {
    if (!e.target.files) {
      return;
    }

    const file = e.target.files[0];
    const formData = new FormData();

    formData.append("typeArch", "logo");
    formData.append("mode", mode);
    formData.append("file", file);

    await api.post("/settings-whitelabel/logo", formData, {
      onUploadProgress: (event) => {
        let progress = Math.round(
          (event.loaded * 100) / event.total
        );
        console.log(
          `A imagem  está ${progress}% carregada... `
        );
      },
    }).then((response) => {
      updateSettingsLoaded(`appLogo${mode}`, response.data);
      colorMode[`setAppLogo${mode}`](getBackendUrl() + "/public/" + response.data);
    }).catch((err) => {
      console.error(
        `Houve um problema ao realizar o upload da imagem.`
      );
      console.log(err);
      toast.error("Houve um problema ao enviar a imagem. Tente novamente.");
    });
  };

  const soundUrl = (file) => {
    if (!file) return null;
    return `${getBackendUrl()}/public/company1/sound/${file}`;
  };

  const [sefazCertFile, setSefazCertFile] = useState(null);
  const [sefazCertPassword, setSefazCertPassword] = useState("");
  const [sefazStatus, setSefazStatus] = useState(null);
  const [sefazUploading, setSefazUploading] = useState(false);
  const [sefazTesting, setSefazTesting] = useState(false);

  useEffect(() => {
    api.get("/settings-sefaz/certificate")
      .then(({ data }) => setSefazStatus(data))
      .catch(() => {});
  }, []);

  const handleUploadSefazCert = async () => {
    if (!sefazCertFile) {
      toast.error("Selecione o arquivo do certificado (.pfx/.p12)");
      return;
    }
    setSefazUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", sefazCertFile);
      formData.append("password", sefazCertPassword);
      const { data } = await api.post("/settings-sefaz/certificate", formData);
      toast.success("Certificado enviado!");
      setSefazCertFile(null);
      setSefazCertPassword("");
      setSefazStatus((prev) => ({ ...prev, configured: true, uploadedAt: data.uploadedAt, lastCheckStatus: null, lastCheckMessage: null }));
    } catch (err) {
      toastError(err);
    } finally {
      setSefazUploading(false);
    }
  };

  const handleTestSefaz = async () => {
    setSefazTesting(true);
    try {
      const { data } = await api.post("/settings-sefaz/test");
      setSefazStatus((prev) => ({
        ...prev,
        lastCheckStatus: data.online ? "online" : "offline",
        lastCheckAt: new Date().toISOString(),
        lastCheckMessage: data.rawMessage,
      }));
      if (data.online) {
        toast.success("SEFAZ respondeu: serviço em operação");
      } else {
        toast.error(`SEFAZ fora do ar ou certificado recusado: ${data.rawMessage}`);
      }
    } catch (err) {
      toastError(err);
    } finally {
      setSefazTesting(false);
    }
  };

  const handleRemoveSefazCert = async () => {
    try {
      await api.delete("/settings-sefaz/certificate");
      setSefazStatus({ configured: false });
      toast.success("Certificado removido.");
    } catch (err) {
      toastError(err);
    }
  };

  const uploadSound = async (e, soundKey) => {
    if (!e.target.files) {
      return;
    }

    const file = e.target.files[0];
    const formData = new FormData();

    formData.append("typeArch", "sound");
    formData.append("soundKey", soundKey);
    formData.append("file", file);

    const setterNames = {
      ticket: "setSoundTicket",
      message: "setSoundMessage",
      attention: "setSoundAttention",
      login: "setSoundLogin",
    };

    await api.post("/settings-sounds/sound", formData).then((response) => {
      updateSettingsLoaded(`sound_${soundKey}`, response.data);
      colorMode[setterNames[soundKey]](soundUrl(response.data));
    }).catch((err) => {
      console.error(`Houve um problema ao realizar o upload do som.`);
      console.log(err);
      toast.error("Houve um problema ao enviar o som. Tente novamente.");
    });
  };

  return (
    <>
      <Grid spacing={3} container>
        {/* <Grid xs={12} item>
                    <Title>Configurações Gerais</Title>
                </Grid> */}
        <OnlyForSuperUser
          user={currentUser}
          yes={() => (
            <>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="primary-color-light-field"
                    label="Cor Primária Modo Claro"
                    variant="standard"
                    value={settingsLoaded.primaryColorLight || ""}
                    onClick={() => setPrimaryColorLightModalOpen(true)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div
                            style={{ backgroundColor: settingsLoaded.primaryColorLight }}
                            className={classes.colorAdorment}
                          ></div>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton
                          size="small"
                          color="default"
                          onClick={() => setPrimaryColorLightModalOpen(true)}
                        >
                          <Colorize />
                        </IconButton>
                      ),
                    }}
                  />
                </FormControl>
                <ColorBoxModal
                  open={primaryColorLightModalOpen}
                  handleClose={() => setPrimaryColorLightModalOpen(false)}
                  onChange={(color) => {
                    handleSaveSetting("primaryColorLight", `#${color.hex}`);
                    colorMode.setPrimaryColorLight(`#${color.hex}`);
                  }}


                  currentColor={settingsLoaded.primaryColorLight}
                />

              </Grid>
              <Grid xs={12} sm={6} md={4} item>

                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="primary-color-dark-field"
                    label="Cor Primária Modo Escuro"
                    variant="standard"
                    value={settingsLoaded.primaryColorDark || ""}
                    onClick={() => setPrimaryColorDarkModalOpen(true)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div
                            style={{ backgroundColor: settingsLoaded.primaryColorDark }}
                            className={classes.colorAdorment}
                          ></div>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton
                          size="small"
                          color="default"
                          onClick={() => setPrimaryColorDarkModalOpen(true)}
                        >
                          <Colorize />
                        </IconButton>
                      ),
                    }}
                  />
                </FormControl>
                <ColorBoxModal
                  open={primaryColorDarkModalOpen}
                  handleClose={() => setPrimaryColorDarkModalOpen(false)}
                  onChange={(color) => {
                    handleSaveSetting("primaryColorDark", `#${color.hex}`);
                    colorMode.setPrimaryColorDark(`#${color.hex}`);
                  }}
                  currentColor={settingsLoaded.primaryColorDark}
                />
              </Grid>

              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="appname-field"
                    label="Nome do sistema"
                    variant="standard"
                    name="appName"
                    value={appName}
                    inputRef={appNameInput}
                    onChange={(e) => {
                      setAppName(e.target.value);
                    }}
                    onBlur={async (_) => {
                      await handleSaveSetting("appName", appName);
                      colorMode.setAppName(appName || "Multi100");
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="logo-light-upload-field"
                    label="Logotipo claro"
                    variant="standard"
                    value={settingsLoaded.appLogoLight || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoLight &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoLight", "");
                                colorMode.setAppLogoLight(defaultLogoLight);
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-logo-light-button"
                            ref={logoLightInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "Light")}
                          />
                          <label htmlFor="upload-logo-light-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoLightInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="logo-dark-upload-field"
                    label="Logotipo escuro"
                    variant="standard"
                    value={settingsLoaded.appLogoDark || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoDark &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoDark", "");
                                colorMode.setAppLogoDark(defaultLogoDark);
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-logo-dark-button"
                            ref={logoDarkInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "Dark")}
                          />
                          <label htmlFor="upload-logo-dark-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoDarkInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <FormControl className={classes.selectContainer}>
                  <TextField
                    id="logo-favicon-upload-field"
                    label="Favicon"
                    variant="standard"
                    value={settingsLoaded.appLogoFavicon || ""}
                    InputProps={{
                      endAdornment: (
                        <>
                          {settingsLoaded.appLogoFavicon &&
                            <IconButton
                              size="small"
                              color="default"
                              onClick={() => {
                                handleSaveSetting("appLogoFavicon", "");
                                colorMode.setAppLogoFavicon(defaultLogoFavicon);
                              }
                              }
                            >
                              <Delete />
                            </IconButton>
                          }
                          <input
                            type="file"
                            id="upload-logo-favicon-button"
                            ref={logoFaviconInput}
                            className={classes.uploadInput}
                            onChange={(e) => uploadLogo(e, "Favicon")}
                          />
                          <label htmlFor="upload-logo-favicon-button">
                            <IconButton
                              size="small"
                              color="default"
                              onClick={
                                () => {
                                  logoFaviconInput.current.click();
                                }
                              }
                            >
                              <AttachFile />
                            </IconButton>
                          </label>
                        </>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoLightPreviewDiv}>
                  <img className={classes.appLogoLightPreviewImg} alt="light-logo-preview" />
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoDarkPreviewDiv}>
                  <img className={classes.appLogoDarkPreviewImg} alt="dark-logo-preview" />
                </div>
              </Grid>
              <Grid xs={12} sm={6} md={4} item>
                <div className={classes.appLogoFaviconPreviewDiv}>
                  <img className={classes.appLogoFaviconPreviewImg} alt="favicon-preview" />
                </div>
              </Grid>

              <Grid xs={12} item>
                <h3>Sons de notificação</h3>
              </Grid>

              {[
                { key: "ticket", label: "Notificação de ticket", ref: soundTicketInput },
                { key: "message", label: "Mensagem em ticket aberto", ref: soundMessageInput },
                { key: "attention", label: "Atenção / Urgente", ref: soundAttentionInput },
                { key: "login", label: "Login do usuário", ref: soundLoginInput },
              ].map(({ key, label, ref }) => (
                <Grid xs={12} sm={6} md={3} item key={key}>
                  <FormControl className={classes.selectContainer}>
                    <TextField
                      id={`sound-${key}-upload-field`}
                      label={label}
                      variant="standard"
                      value={settingsLoaded[`sound_${key}`] || ""}
                      InputProps={{
                        endAdornment: (
                          <>
                            <input
                              type="file"
                              accept="audio/*"
                              id={`upload-sound-${key}-button`}
                              ref={ref}
                              className={classes.uploadInput}
                              onChange={(e) => uploadSound(e, key)}
                            />
                            <label htmlFor={`upload-sound-${key}-button`}>
                              <IconButton
                                size="small"
                                color="default"
                                onClick={() => {
                                  ref.current.click();
                                }}
                              >
                                <AttachFile />
                              </IconButton>
                            </label>
                          </>
                        ),
                      }}
                    />
                  </FormControl>
                  {settingsLoaded[`sound_${key}`] && (
                    <audio controls src={soundUrl(settingsLoaded[`sound_${key}`])} style={{ width: "100%", marginTop: 8 }} />
                  )}
                </Grid>
              ))}

              <Grid xs={12} item>
                <h3>Certificado digital SEFAZ (NFCe/NFe)</h3>
                <p style={{ fontSize: 13, color: "#666", marginTop: -8 }}>
                  Usado pra monitorar se os webservices do SEFAZ estão no ar. Aceita certificado A1 (.pfx/.p12).
                </p>
              </Grid>

              <Grid xs={12} sm={4} item>
                <input
                  type="file"
                  accept=".pfx,.p12"
                  id="upload-sefaz-cert-button"
                  style={{ display: "none" }}
                  onChange={(e) => setSefazCertFile(e.target.files?.[0] || null)}
                />
                <label htmlFor="upload-sefaz-cert-button">
                  <Button variant="outlined" component="span" fullWidth>
                    {sefazCertFile ? sefazCertFile.name : "Escolher arquivo .pfx"}
                  </Button>
                </label>
              </Grid>
              <Grid xs={12} sm={4} item>
                <TextField
                  fullWidth
                  variant="standard"
                  type="password"
                  label="Senha do certificado"
                  value={sefazCertPassword}
                  onChange={(e) => setSefazCertPassword(e.target.value)}
                />
              </Grid>
              <Grid xs={12} sm={4} item style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={sefazUploading || !sefazCertFile}
                  onClick={handleUploadSefazCert}
                >
                  {sefazUploading ? "Enviando..." : "Enviar certificado"}
                </Button>
              </Grid>

              {sefazStatus?.configured && (
                <Grid xs={12} item>
                  <p style={{ fontSize: 13, margin: "4px 0" }}>
                    Certificado instalado{sefazStatus.uploadedAt ? ` em ${new Date(sefazStatus.uploadedAt).toLocaleString("pt-BR")}` : ""}.
                    {" "}
                    <Button size="small" color="secondary" onClick={handleRemoveSefazCert}>Remover</Button>
                  </p>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={sefazTesting}
                    onClick={handleTestSefaz}
                  >
                    {sefazTesting ? "Testando..." : "Testar conexão agora"}
                  </Button>
                  {/* Fix 2026-09-08: este bloco lia sefazStatus.lastCheckStatus
                      e .lastCheckMessage, campos que GET /settings-sefaz/certificate
                      nunca devolveu, e comparava com "online", valor que
                      tambem nunca existiu (os status reais sao
                      normal/lento/muito_lento/timeout/erro) - ou seja, nunca
                      renderizou nada. Agora le o formato real do endpoint:
                      por documento e por fonte. */}
                  {["nfce", "nfe"].map((doc) => {
                    const porFonte = sefazStatus[doc];
                    if (!porFonte) return null;
                    return (
                      <p key={doc} style={{ fontSize: 13, marginTop: 6 }}>
                        <strong>{doc === "nfce" ? "NFC-e" : "NF-e"}:</strong>{" "}
                        {Object.keys(porFonte).map((fonte) => (
                          <span key={fonte} style={{ marginRight: 12 }}>
                            {fonte === "tecnospeed" ? "envio" : "conexão"}{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color:
                                  porFonte[fonte].status === "normal"
                                    ? "#2e7d32"
                                    : "#c62828",
                              }}
                            >
                              {porFonte[fonte].status}
                            </span>
                          </span>
                        ))}
                      </p>
                    );
                  })}
                  <p style={{ fontSize: 13, marginTop: 6, color: "#666" }}>
                    Histórico completo de quedas e lentidões no menu "Monitor SEFAZ".
                  </p>
                </Grid>
              )}
            </>
          )}
        />
      </Grid>
    </>
  );
}
